<template>
  <div class="LC_synergisticEffect" ref="LC_synergisticEffect" >
    <div class="tips">吨污染物/吨C02</div>
    <div class="monitorPointsBg"></div>
    <ul class="title">
      <li>智能管控前</li>
      <li>智能管控后</li>
    </ul>
    <ul class="main">
      <li v-for="(item,i) in dataList" :key="i">
        <div class="li_name">
          {{ item.name }}
        </div>
        <div class="li_value">
          {{ item.beforeValue??'--' }}
        </div>
        <div class="li_value">
          {{ item.afterValue??'--' }}
        </div>
        <div class="li_per ">
          <div class="li_per_left" :style="getImg(item.status)"></div>
          <div class="li_per_right number">
            <span :style="{'color':countColor(i)}">{{item.percent??'--'}}</span> %
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>



<script>
import lowCarbonPopup2 from "@/modules/lowcarbonComponents/lowCarbonPopup2/indexNew.vue";
import { mapGetters } from "vuex";
export default {
  props: ["matrix", "x", "y"],
  components: {
    lowCarbonPopup2,
  },
  data() {
    return {
      pageInfo: 'LC_synergisticEffect.vue',
      computedName: '减污降碳协同效果组件',
      customerId: this.$store.state.customerId,
      dataList: [
        {
          key: "",
          name: "颗粒物",
          beforeValue: null,
          afterValue: null,
          percent: null,
          status: 0,
        },
        {
          key: "",
          name: "SO₂",
          beforeValue: null,
          afterValue: null,
          percent: null,
          status: 1,
        },
        {
          key: "",
          name: "NOx",
          beforeValue: null,
          afterValue: null,
          percent: null,
          status: 1,
        },
      ],
      setTime1: null,
    };
  },
  computed: {
    countColor() {
      return (i) => {
        if (i == 0) {
          return "#f4d29c";
        } else if (i == 1) {
          return "#8de4f3";
        } else if (i == 2) {
          return "#b6ffc6";
        } else {
          return "#9278ff";
        }
      };
    },
    getImg() {
      return (i) => {
        let bg_url;
        if (i == 0) {
          bg_url = require("./img/down.png");
        } else {
          bg_url = require("./img/up.png");
        }
        let url = "url(" + bg_url + ")";
        return {
          backgroundImage: url,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        };
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },

  watch: {},

  created() {},

  mounted() {
    let that = this;
    let w = $(that.$refs.LC_synergisticEffect).outerWidth();
    let h = $(that.$refs.LC_synergisticEffect).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    // this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    rowClick() {
      //console.log("sss", i);
      this.$store.commit("dialogStatus", true);
      this.$popup.open(lowCarbonPopup2, this.dialogCompontent);
    },
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getCarbonEmissionType =
          CONFIG.requestName + this.$apiOpt.getCarbonEmissionType;
        let res = await this.$apiUtils.get(getCarbonEmissionType, {
          customerId: this.customerId,
        });

        this.dataList = res;
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 30);
    },
  },
};
</script>



<style lang="scss" scoped="scoped">
.LC_synergisticEffect {
  height: 250px;
  width: 600px;
  .tips {
    position: absolute;
    right: 20px;
    font-size: 18px;
    color: #e2effd;
    line-height: 18px;
  }
  .monitorPointsBg {
    @include bg-box(560px, 178px, "wrapbg.png");
    margin-top: 32px;
    position: absolute;
    z-index: 0;
  }
  .title {
    display: flex;
    margin-top: 46px;
    padding: 0 107px 0 111px;
    justify-content: space-around;
    li {
      z-index: 1;
      font-size: 16px;
      font-weight: 600;
      color: #eef7f6;
    }
  }
  .main {
    padding: 0px 10px;
    margin-top: 5px;
    height: 127px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    li {
      z-index: 1;
      display: flex;
      width: 100%;
      height: 30px;
      margin-bottom: 6px;
      padding: 0 5px;
      align-items: center;
      text-align: center;
      .li_name {
        width: 94px;
        font-size: 16px;
        font-weight: 600;
        color: #000;
        line-height: 30px;
      }
      .li_value {
        font-size: 22px;
        font-weight: 400;
        color: #f4d29c;
        line-height: 30px;
        width: 170px;
        // background: blue;
      }
      .li_per {
        width: 97px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 13px;
        .li_per_left {
          width: 10px;
          height: 16px;
        }
        .li_per_right {
          font-size: 22px;
          font-weight: 400;
          color: #d5efff;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
